// クラブのアバター画像定義 + peer id → アバター割り当て。
//
// 画像は `public/avatars/<key>.png` に配置する (= Vite が `dist/avatars/<key>.png`
// に出力 → Cloudflare Workers の [assets] binding が直接配信)。
// 生成 / 配置の手順は `docs/AVATAR_GENERATION.md` に記載。
//
// `AVATARS` が空 ([]) の場合、scene.ts は棒人間 (drawStick) にフォールバックする。
// = アバター画像がまだ無い状態でも /club は動く。

export interface AvatarDef {
  /** Phaser の texture key にもなる。一意であること。 */
  key: string;
  /** ブラウザから fetch する URL。public/avatars/ 直下を想定。 */
  url: string;
  /** /club3d 用の glTF (.glb) URL。`public/avatars/<key>.glb` 等を想定。
   *  未設定なら /club3d は **プリミティブ Capsule** にフォールバック (= /club と
   *  同じく「アバター画像 (3D 版) がまだ無い状態でも動く」)。設定済みの場合、
   *  /club3d は `/assets/avatars/<allowlisted-key>.glb` 固定 path で GLTFLoader
   *  経由でロード (security: URL をクライアントに組ませない)。 */
  glbUrl?: string;
  /** 入室前の選択 UI に出すラベル (省略時は key)。 */
  label?: string;
}

export const AVATARS: readonly AvatarDef[] = [
  { key: "m01", url: "/avatars/m01.png", label: "男性 1" },
  { key: "f01", url: "/avatars/f01.png", label: "女性 1" },
];

/** FNV-1a (32-bit) で peer id を hashing し、AVATARS から決定論的に 1 体選ぶ。
 *  - 同じ id なら毎回同じアバターが返る (= 自分から見ても他人から見ても peer X は同じ姿)。
 *  - AVATARS が空なら null (= 棒人間 fallback を使ってもらう)。
 */
export function getAvatarForPeerId(id: string): AvatarDef | null {
  if (AVATARS.length === 0) return null;
  let h = 0x811c9dc5;
  for (let i = 0; i < id.length; i++) {
    h ^= id.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  const idx = h % AVATARS.length;
  return AVATARS[idx] ?? null;
}
